import GeneralError from './GeneralError'

export default GeneralError
